/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:f4027b84-7103-494b-a2bd-aa5b7c9dea9a",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_pozVZjf0d",
    "aws_user_pools_web_client_id": "3aj8c2ak7050njlo27gk41omvu",
    "oauth": {
        "domain": "u1dentappe44a9b7b-e44a9b7b-dev.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "u1dent://,http://localhost:19006/,https://web.u1dent.app/,exp://exp.host/@brataaaan/u1Dent/--/,exp://127.0.0.1:19000/--/,https://localhost:19006/",
        "redirectSignOut": "u1dent://,http://localhost:19006/,https://web.u1dent.app/,exp://exp.host/@brataaaan/u1Dent/--/,exp://127.0.0.1:19000/--/,https://localhost:19006/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://rojp52uh6e.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://36fsklfzuzbqzo7xxeuyqek2oa.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
